<app-shared-left-menu [isVisible]="isVisible" (isVisibleChange)="onIsVisibleChange($event)" (signOut)="signOut()">
    @for (menuItem of menuItems; track menuItem.url) {
        <a class="left-menu-item py-1 col-12" (click)="navigate(menuItem.url)">
            <fa-icon class="mx-2 col-1 d-inline-block" [icon]="['fas', menuItem.icon]"></fa-icon>
            <span class="col-10 d-inline-block">{{ menuItem.title }}</span>
        </a>
    }
</app-shared-left-menu>
